import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';
import { useFetch } from "../../../context/fetch";

const CAPACITY_LOGS_ENDPOINT = "orders/logs";

const capacityLogsKeys = {
  all   : [ "capacity_logs" ] as const,
  lists : () => [ ...capacityLogsKeys.all, "list" ] as const,
  list  : (filters?: UseApprovalsFilters) => [ ...capacityLogsKeys.lists(), filters ] as const,
};

type ApprovalsPageAttr = {
  data: Array<{
    rate: number;
    origin: {
      arrive_early_datetime: Date;
    };
  }>;
  pagination: {
    count: number;
    limit: number;
    page: number;
  };
}

type UseApprovalsFilters = Partial<{
  equipment_type: string;
  carrier: string | null;
  destination: string;
  origin: string;
  limit: number;
  page: number;
}>

const useCapacityLogs = (
  filters: UseApprovalsFilters,
  config?: UseQueryOptions<ApprovalsPageAttr>,
): UseQueryResult<ApprovalsPageAttr> => {
  const { authRequest } = useFetch();

  return useQuery<ApprovalsPageAttr>(
    capacityLogsKeys.list(filters),
    async () => (await authRequest.get<ApprovalsPageAttr>(CAPACITY_LOGS_ENDPOINT, { params: filters })).data,
    config,
  );
};

export { capacityLogsKeys, useCapacityLogs };
